import HLSPage from "./video"
import './App.css';

function App() {
  return (
    <div className="App">
      <HLSPage />
    </div>
  );
}

export default App;
